<fui-page>
    <fui-page-pane>
        <file-upload (onConfirm)="importFile($event)" (onCancel)="onCancel()"></file-upload>
        <fui-page-header [description]="'wbo.file-import.import.description'" [hasToggle]="false"
                         [title]="'wbo.file-import.import.title'">
        </fui-page-header>
        <fui-page-body>
            <fui-page-main>
                <fui-page-subject>
                    <fui-rows *ngIf="importing">
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <fui-inline-information [title]="'wbo.file-import.import.status.processing.title'"
                                                            [message]="'wbo.file-import.import.status.processing.message'"
                                                            [messageParams]="{'percentage': percentageComplete}"></fui-inline-information>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <fui-ellipsis-loader></fui-ellipsis-loader>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                    </fui-rows>
                    <fui-rows *ngIf="!importing && started">
                        <fui-row>
                            <fui-two-columns>
                                <fui-column *ngIf="success">
                                    <fui-inline-success [title]="'wbo.file-import.import.status.success.title'"
                                                      [message]="'wbo.file-import.import.status.success.message'"></fui-inline-success>
                                </fui-column>
                                <fui-column *ngIf="!success">
                                    <fui-inline-error [title]="'wbo.file-import.import.status.failed.title'"
                                                            [message]="'wbo.file-import.import.status.failed.message'"></fui-inline-error>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                    </fui-rows>
                </fui-page-subject>
            </fui-page-main>
        </fui-page-body>
    </fui-page-pane>
</fui-page>
